import { isCloudflareRealtime } from './realtimeConfig';
import { createCloudflareOnlineTransport } from './cloudflareOnlineTransport';
import { createSupabaseOnlineTransport } from './supabaseOnlineTransport';
import type { OnlineTransport, OnlineTransportCallbacks, OnlineTransportOptions } from './onlineTransport';

export type { OnlineTransport, OnlineTransportCallbacks, OnlineTransportOptions } from './onlineTransport';
export { isCloudflareRealtime, REALTIME_PROVIDER } from './realtimeConfig';

/** env(REACT_APP_REALTIME_PROVIDER)에 따라 온라인 전송 구현 선택 — 기본 Supabase */
export function createOnlineTransport(opts: OnlineTransportOptions, cb: OnlineTransportCallbacks): OnlineTransport {
  return isCloudflareRealtime() ? createCloudflareOnlineTransport(opts, cb) : createSupabaseOnlineTransport(opts, cb);
}
